import { render, staticRenderFns } from "./Countries.vue?vue&type=template&id=b58080ae&scoped=true"
import script from "./Countries.vue?vue&type=script&lang=js"
export * from "./Countries.vue?vue&type=script&lang=js"
import style0 from "./Countries.vue?vue&type=style&index=0&id=b58080ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58080ae",
  null
  
)

export default component.exports